import ApiService from '../api'

class NewsApiService {

  // Public API methods - FIXED FOR YOUR EXACT API STRUCTURE
  async getPublicNews(params = {}) {
    try {
      const response = await ApiService.get('/news', params)
      const raw = response.data ?? response
      const payload = raw.Data || raw

      return {
        success: (payload.success ?? raw.Success) ?? false,
        data: payload.data || [],
        pagination: payload.pagination || {
          current_page: params.page ?? 1,
          total_pages: 1,
          per_page: params.per_page ?? 10,
          total: (payload.data || []).length
        }
      }
    } catch (error) {
      console.error('❌ News API Service Error:', error)
      return {
        success: false,
        data: [],
        pagination: {
          current_page: params.page ?? 1,
          total_pages: 1,
          per_page: params.per_page ?? 10,
          total: 0
        }
      }
    }
  }

  async getPublicHomeNews(params = {}) {
    try {
      const response = await ApiService.get('/news', { params });

      if (response && (response.Success || response.success)) {
        // Handle your nested structure
        const dataContainer = response.Data || response.data || response;
        const articles = dataContainer.data || [];
        const pagination = dataContainer.pagination || {
          current_page: 1,
          total_pages: 1,
          per_page: params.per_page || 10,
          total: articles.length
        };

        return {
          success: true,
          data: {
            data: articles,
            pagination: pagination
          }
        };
      }

      if (Array.isArray(response)) {
        return {
          success: true,
          data: {
            data: response,
            pagination: {
              current_page: 1,
              total_pages: 1,
              per_page: params.per_page || 10,
              total: response.length
            }
          }
        };
      }
    } catch (error) {
      console.error('News API Service Error:', error);
      return {
        success: false,
        message: 'Failed to fetch news articles',
        data: {
          data: [],
          pagination: {
            current_page: 1,
            total_pages: 1,
            per_page: params.per_page || 10,
            total: 0
          }
        }
      };
    }
  }

  async getPublicNewsById(id) {
    try {
      const response = await ApiService.get(`/news/${id}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Admin API methods - FIXED FOR YOUR EXACT API STRUCTURE
  async getAdminNews(params = {}) {
    try {
      console.log('=== ADMIN NEWS API SERVICE DEBUG ===');
      const response = await ApiService.get('/news/admin/list', { params });
      console.log('Admin API raw response:', response);

      // YOUR ACTUAL API STRUCTURE:
      // { Data: { success: true, data: [...], pagination: {...} }, Success: true, Message: null }

      if (response && (response.Success || response.success)) {
        console.log('Admin success response detected');

        // Handle your nested structure
        const dataContainer = response.Data || response.data || response;
        const articles = dataContainer.data || [];
        const pagination = dataContainer.pagination || {
          current_page: 1,
          total_pages: 1,
          per_page: params.per_page || 15,
          total: articles.length
        };

        return {
          success: true,
          data: {
            data: articles,
            pagination: pagination
          }
        };
      }

      return {
        success: false,
        message: 'Failed to fetch admin news',
        data: {
          data: [],
          pagination: {
            current_page: 1,
            total_pages: 1,
            per_page: params.per_page || 15,
            total: 0
          }
        }
      };
    } catch (error) {
      console.error('Error fetching admin news:', error);
      return {
        success: false,
        message: 'Failed to fetch news articles',
        data: {
          data: [],
          pagination: {
            current_page: 1,
            total_pages: 1,
            per_page: params.per_page || 15,
            total: 0
          }
        }
      };
    }
  }

  async createNews(newsData) {
    try {
      console.log('=== API SERVICE DEBUG ===');
      console.log('Input data:', newsData);

      const formData = new FormData();
      formData.append('title', newsData.title || '');
      formData.append('content', newsData.content || '');
      formData.append('date', newsData.date || '');
      formData.append('is_featured', newsData.is_featured ? '1' : '0');

      if (newsData.featured_image && newsData.featured_image instanceof File && newsData.featured_image.size > 0) {
        formData.append('featured_image', newsData.featured_image);
        console.log('Image included:', newsData.featured_image.name);
      }

      const response = await ApiService.post('/news', {}, formData);
      console.log('Create response:', response);

      if (response && response.Success) {
        return {
          success: true,
          data: response.Data || response.data,
          message: response.Message || 'News created successfully'
        };
      }

      return {
        success: true,
        data: response.data?.data || response.data,
        message: response.data?.message || 'News created successfully'
      };

    } catch (error) {
      console.error('API Error:', error);

      if (error.response) {
        return {
          success: false,
          message: error.response.data.message || 'Failed to create news',
          errors: error.response.data.errors || {},
          status: error.response.status
        };
      }

      return {
        success: false,
        message: 'Network error occurred',
        errors: {},
        status: null
      };
    }
  }

  async updateNews(id, newsData) {
    try {
      const formData = new FormData();
      formData.append('title', newsData.title || '');
      formData.append('content', newsData.content || '');
      formData.append('date', newsData.date || '');
      formData.append('is_featured', newsData.is_featured ? '1' : '0');
      formData.append('_method', 'PUT');

      if (newsData.featured_image && newsData.featured_image instanceof File && newsData.featured_image.size > 0) {
        formData.append('featured_image', newsData.featured_image);
      }

      const response = await ApiService.post(`/news/${id}`, {}, formData);

      if (response && response.Success) {
        return {
          success: true,
          data: response.Data || response.data,
          message: response.Message || 'News updated successfully'
        };
      }

      return {
        success: true,
        data: response.data?.data || response.data,
        message: response.data?.message || 'News updated successfully'
      }
    } catch (error) {
      console.error('NewsApiService updateNews error:', error)
      return this.handleError(error)
    }
  }

  async deleteNews(id) {
    try {
      const response = await ApiService.delete(`/news/${id}`);

      return {
        success: response.Success ?? response.Data?.success ?? false,
        data: response.Data ?? null,
        message: response.Message ?? response.Data?.message ?? null
      };

    } catch (error) {
      throw this.handleError(error);
    }
  }

  async bulkDeleteNews(ids) {
    try {
      const response = await ApiService.post('/news/bulk-delete', {}, { ids });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async getFeaturedNews(params = {}) {
    try {
      const response = await ApiService.get('/news/featured', { params });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async toggleFeatureStatus(id, isFeatured) {
    try {
      const response = await ApiService.patch(`/news/${id}/feature`, {}, {
        is_featured: isFeatured
      });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async uploadNewsImage(file) {
    try {
      const formData = new FormData();
      formData.append('image', file);

      const response = await ApiService.post('/news/upload-image', {}, formData);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async deleteNewsImage(imageId) {
    try {
      const response = await ApiService.delete(`/news/images/${imageId}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Utility methods
  formatNewsDate(dateString) {
    const date = new Date(dateString);
    const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    };
    return date.toLocaleDateString('en-US', options);
  }

  truncateContent(content, maxLength = 150) {
    if (!content) return '';
    const textContent = content.replace(/<[^>]*>/g, '');
    return textContent.length > maxLength
      ? textContent.substring(0, maxLength) + '...'
      : textContent;
  }

  sanitizeHtmlContent(content) {
    return content;
  }

  stripHtmlTags(content) {
    return content.replace(/<[^>]*>/g, '');
  }

  validateImageFile(file) {
    const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
    const maxSize = 5 * 1024 * 1024; // 5MB

    if (!allowedTypes.includes(file.type)) {
      return {
        valid: false,
        error: 'Please select a valid image file (JPEG, PNG, GIF, or WebP)'
      };
    }

    if (file.size > maxSize) {
      return {
        valid: false,
        error: 'Image file size must be less than 5MB'
      };
    }

    return { valid: true };
  }

  handleError(error) {
    console.error('API Error Details:', {
      message: error.message,
      response: error.response,
      request: error.request
    });

    if (error.response) {
      const errorData = error.response.data;
      return {
        success: false,
        message: errorData.message || 'An error occurred',
        status: error.response.status,
        data: {
          errors: errorData.errors || {},
          ...errorData
        }
      };
    } else if (error.request) {
      return {
        success: false,
        message: 'Network error - please check your connection',
        status: null,
        data: {}
      };
    } else {
      return {
        success: false,
        message: error.message || 'An unexpected error occurred',
        status: null,
        data: {}
      };
    }
  }

  buildSearchParams(filters = {}) {
    const params = {};

    if (filters.search) params.search = filters.search;
    if (filters.per_page) params.per_page = filters.per_page;
    if (filters.page) params.page = filters.page;
    if (filters.date_from) params.date_from = filters.date_from;
    if (filters.date_to) params.date_to = filters.date_to;
    if (filters.is_featured !== undefined) params.is_featured = filters.is_featured;
    if (filters.author_id) params.author_id = filters.author_id;
    if (filters.status) params.status = filters.status;

    return params;
  }

  formatContentForDisplay(content) {
    if (!content) return '';

    let formattedContent = content.replace(/\n\n/g, '</p><p>');
    formattedContent = formattedContent.replace(/\n/g, '<br>');

    if (!formattedContent.startsWith('<p>')) {
      formattedContent = '<p>' + formattedContent + '</p>';
    }

    return formattedContent;
  }

  formatContentForEdit(content) {
    if (!content) return '';

    return content
      .replace(/<\/p><p>/g, '\n\n')
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<\/?p>/g, '');
  }

  formatDateForInput(dateString) {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toISOString().split('T')[0];
  }

  formatDateTimeForDisplay(dateTimeString) {
    if (!dateTimeString) return '';
    const date = new Date(dateTimeString);
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  insertTextAtCursor(text) {
    if (document.selection) {
      const range = document.selection.createRange();
      range.text = text;
    } else if (document.getSelection) {
      const selection = document.getSelection();
      if (selection.rangeCount > 0) {
        const range = selection.getRangeAt(0);
        range.deleteContents();
        range.insertNode(document.createTextNode(text));
      }
    }
  }

  execCommand(command, value = null) {
    document.execCommand(command, false, value);
  }

  formatFileSize(bytes) {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }

  generateSlug(title) {
    return title
      .toLowerCase()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .trim();
  }

  validateNewsData(data) {
    const errors = {};

    if (!data.title || data.title.trim().length === 0) {
      errors.title = ['Title is required'];
    } else if (data.title.length > 255) {
      errors.title = ['Title must be less than 255 characters'];
    }

    if (!data.content || data.content.trim().length === 0) {
      errors.content = ['Content is required'];
    }

    if (!data.date) {
      errors.date = ['Date is required'];
    } else {
      const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
      if (!dateRegex.test(data.date)) {
        errors.date = ['Date must be in YYYY-MM-DD format'];
      }
    }

    return {
      isValid: Object.keys(errors).length === 0,
      errors
    };
  }

  calculateReadingTime(content) {
    if (!content) return 0;

    const wordsPerMinute = 200;
    const textContent = this.stripHtmlTags(content);
    const wordCount = textContent.split(/\s+/).length;

    return Math.ceil(wordCount / wordsPerMinute);
  }

  getContentWordCount(content) {
    if (!content) return 0;

    const textContent = this.stripHtmlTags(content);
    return textContent.split(/\s+/).filter(word => word.length > 0).length;
  }

  generatePreview(content, length = 200) {
    if (!content) return '';

    const textContent = this.stripHtmlTags(content);
    return textContent.length > length
      ? textContent.substring(0, length) + '...'
      : textContent;
  }
}

export default new NewsApiService()
